import { render, staticRenderFns } from "./SingleCommercialPrintToolbarMenu.vue?vue&type=template&id=bda2ecd6"
import script from "./SingleCommercialPrintToolbarMenu.vue?vue&type=script&lang=js"
export * from "./SingleCommercialPrintToolbarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports